import { useForm } from '@mantine/form';
import { useState } from 'react';

export type ExportConfirmationForm = {
	selectedExport: string;
	pdfName: string;
	excelName: string;
	title: string;
};

const defaultAfterVat: ExportConfirmationForm = {
	selectedExport: 'excel',
	pdfName: '',
	excelName: '',
	title: '',
};

export function useExportConfirmationForm() {
	const [inputs, setInputs] = useState<ExportConfirmationForm>(defaultAfterVat);

	const form = useForm<ExportConfirmationForm>({
		mode: 'uncontrolled',
		initialValues: inputs,
		validate: {
			selectedExport: (v) => !v && 'Please select a value',
			pdfName: (v, values) =>
				(values.selectedExport === 'pdf' || values.selectedExport === 'both') &&
				!v?.length &&
				'Please insert value',
			excelName: (v, values) =>
				(values.selectedExport === 'excel' ||
					values.selectedExport === 'both') &&
				!v?.length &&
				'Please insert value',
			title: (v) => (v == null || v === '') && 'Please Organisation Name',
		},
		onValuesChange: (v) => setInputs(v),
		clearInputErrorOnChange: true,
	});

	return { form, inputs };
}
